import React, { useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import useAuthStore from '../../../store/useAuthStore';

// Reusable component for loading spinner and iframe
const IframeWithLoader = ({ src }) => {
  const [isLoading, setIsLoading] = useState(true);

  const handleIframeLoad = () => {
    setIsLoading(false);
  };

  return (
    <div style={{ padding: "20px" }}>
      {/* Loader */}
      {isLoading && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "300px",
            position: "relative",
            zIndex: 1,
          }}
        >
          <i
            className="fas fa-spinner fa-spin"
            style={{ fontSize: "5rem", color: "#007bff" }}
          ></i>
        </div>
      )}

      {/* Iframe */}
      <div
        style={{
          position: "relative",
          width: "100%",
          height: "0",
          paddingTop: "56.2500%",
          paddingBottom: "0",
          boxShadow: "0 2px 8px 0 rgba(63,69,81,0.16)",
          marginTop: "0",
          marginBottom: "0",
          overflow: "hidden",
          borderRadius: "5px",
          willChange: "transform",
          visibility: isLoading ? "hidden" : "visible",
        }}
      >
        <iframe
          loading="lazy"
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            top: "0",
            left: "0",
            border: "none",
            padding: "0",
            margin: "0",
          }}
          src={src}
          onLoad={handleIframeLoad}
          allowFullScreen="allowfullscreen"
          allow="fullscreen"
        ></iframe>
      </div>
    </div>
  );
};

const NEBInteractiveManual = () => {
  const { roles } = useAuthStore(state => ({ roles: state.roles }));

  console.log("roles interactive manual: ", roles);

  // Common menu items for all roles
  const COMMON_MENU = [
    { title: "Mobile Apps", src: "https://www.canva.com/design/DAGgWugZUTY/6ljMTd4zH5kT2y5GrgFZmA/view?embed" },
  ];

  // Menu for NEB Admin and Administrator
  const NEB_ADMIN_MENU = [
    { title: "Dashboard", src: "https://www.canva.com/design/DAGeTtfkD50/l4CXg04_MbY4QxcLW17G_A/view?embed" },
    { title: "Create New Agency", src: "https://www.canva.com/design/DAGfEWlOOP4/OXp0TYtRoRMwv42gxijiYQ/view?embed" },
    { title: "Create Product", src: "https://www.canva.com/design/DAGfFr_yYr8/WWMnRfq-tikiKJPIRaQQaA/view?embed" },
    { title: "Verification List", src: "https://www.canva.com/design/DAGfMSy-OZc/XW9xHrxHJPNDOw85Z0qjDQ/view?embed" },
    { title: "Manual Submission List", src: "https://www.canva.com/design/DAGfMf8de-Y/NPonEjV5D9NPjLGCmWnukg/view?embed" },
    { title: "Ticket Resolution Centre", src: "https://www.canva.com/design/DAGfMR3Qk_c/Jsg5S7vOVwVyYvnQTxMRtg/view?embed" },
    { title: "Admin Portal", src: "https://www.canva.com/design/DAGhkTvVIKU/oOwMoMb8Y7v9zrYQ-J8fuA/view?embed" },
    { title: "News Scrapper", src: "https://www.canva.com/design/DAGiPCvlTig/TqWreMKSdEoy_iUbhG0zsg/view?embed" },
    { title: "Statistic", src: "https://www.canva.com/design/DAGiMlPusn4/AVMKHQYVQ8Rb8s_ANHYf7w/view?embed" },
    { title: "Adiwira", src: "https://www.canva.com/design/DAGhT2NUiwc/QAd7u4j4dHjPm6aUEe01tA/view?embed" },
  ];

  // Menu for Data Provider
  const NEB_DATA_PROVIDER_MENU = [
    { title: "My Profile", src: "https://www.canva.com/design/DAGbZ4S4y-4/g6Ew6t2GqZmWCCKg_xv5Mg/view?embed" },
    { title: "Dashboard", src: "https://www.canva.com/design/DAGbHqJIyAs/7IxCtytlRLKp2xBqVidIUQ/view?embed" },
    { title: "Data Submission", src: "https://www.canva.com/design/DAGbnAtaAdw/j_NSCGnX_ahfUBA9YQ8sug/view?embed" },
    { title: "Manual Submission", src: "https://www.canva.com/design/DAGbNYT_ANw/nCUHPjqaEl64l12_1S9qCw/view?embed" },
    { title: "Report & Resolve Centre", src: "https://www.canva.com/design/DAGbPKa4OVs/MDd7Ak9njnGI-Z12u4jX2Q/view?embed" },
    { title: "FAQ", src: "https://www.canva.com/design/DAGbh3FnYwY/vnJMCQ51DPwLyWYGOHiA-g/view?embed" },
  ];

  // Assign menu based on role and merge with COMMON_MENU
  const contentByRole = {
    NEB_DATA_PROVIDER: [...NEB_DATA_PROVIDER_MENU, ...COMMON_MENU],
    NEB_ADMIN: [...NEB_ADMIN_MENU, ...COMMON_MENU],
    ADMINISTRATOR: [...NEB_ADMIN_MENU, ...COMMON_MENU],
  };

  const userRole = roles.find(role => contentByRole[role]) || "NEB_DATA_PROVIDER";
  const items = contentByRole[userRole] || [];

  return (
    <Accordion>
      {items.map((item, index) => (
        <Accordion.Item eventKey={index.toString()} className="mb-1" key={index}>
          <Accordion.Header className="accordion-bg-color1">
            {index + 1}. {item.title}
          </Accordion.Header>
          <Accordion.Body>
            <IframeWithLoader src={item.src} />
          </Accordion.Body>
        </Accordion.Item>
      ))}
    </Accordion>
  );
};

export default NEBInteractiveManual;
